module.exports = __webpack_public_path__ + "static/extensions1-24f174549dbb4ef988829ca801ce5b50.png";